/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { Modal, Space } from 'antd';

import { CreateApiTokenResponse } from '@/client';
import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Container } from '@/primitives/Container';
import { CopyButton } from '@/primitives/CopyButton';
import { Input } from '@/primitives/Input';
import { Text } from '@/primitives/Text';
import { Title } from '@/primitives/Title';

type APITokenCreatedModalProps = {
  createdToken: CreateApiTokenResponse;
  onClose: () => void;
};

export function APITokenCreatedModal({ createdToken, onClose }: APITokenCreatedModalProps) {
  const { t } = useMimicTranslation('apiTokens');

  return (
    <Modal
      open
      onCancel={onClose}
      onOk={onClose}
      cancelButtonProps={{ style: { display: 'none' } }}
      okText={t('createTokenModal.ok')}
      width={600}
    >
      <Container padding="sm">
        <Title level={4} data-testid="created-token-title">
          {createdToken.data.name}
        </Title>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', width: '100%' }}>
          <Space.Compact>
            <Input readOnly value={createdToken.data.token} dataTestId="token-field" />
            <CopyButton textToCopy={createdToken.data.token} failedText={t('failedCopy')} />
          </Space.Compact>
          <Text type="error">
            <strong>{t('copyTokenWarningNote')}</strong> {t('copyTokenWarning')}
          </Text>
        </div>
      </Container>
    </Modal>
  );
}
